export default __webpack_public_path__ + "static/va-305358ba0ca34016c09fcc2114bdca68.svg";